import styled from 'styled-components'

export const CreateBeneficiaryFormLoadingSkeletonStyled = styled.div`
  padding: ${(props) => props.theme.space.medium};
`
